import { Location } from 'react-router-dom';

export type UrlParamKey = 'utm_source' | 'code';

export const getParam = (key: UrlParamKey, location: Location) => new URLSearchParams(location.search).get(key) ?? null;
